import { render } from "./MfcInputContactsPeople.vue?vue&type=template&id=4e9abb04"
import script from "./MfcInputContactsPeople.vue?vue&type=script&lang=js"
export * from "./MfcInputContactsPeople.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__